import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NewRoofCostZipFormComponent } from '../../../modules/new-roof-cost/components/new-roof-cost-zip-form/new-roof-cost-zip-form.component';
import { StickyZipCtaService } from '../../../core/services/sticky-zip-cta.service';
import { LocationService } from '../../../core/services/location.service';

@Component({
  selector: 'app-sticky-zip-cta',
  standalone: true,
  imports: [CommonModule, NewRoofCostZipFormComponent],
  templateUrl: './sticky-zip-cta.component.html',
  styleUrl: './sticky-zip-cta.component.scss',
})
export class StickyZipCtaComponent implements OnInit {
  fetchedZipcode = '';
  zipVal = '';

  constructor(
    readonly stickyZipCtaService: StickyZipCtaService,
    private locationService: LocationService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.fetchLocationZipcode();
    }
  }

  private fetchLocationZipcode(): void {
    this.locationService.fetchZipcode().subscribe({
      next: res => {
        this.fetchedZipcode = res.zipCode;
        if (res.zipCode) {
          this.zipVal = res.zipCode;
        }
      },
      error: err => console.error('Error fetching zipcode:', err),
    });
  }
}
